export const calculateProyectanteFijo = (width, height, additionalMeasure) => {
  console.log('calculateProyectanteFijo recibió:', {
    width,
    height,
    additionalMeasure,
    types: {
      width: typeof width,
      height: typeof height,
      additionalMeasure: typeof additionalMeasure
    }
  });

  // Validación básica
  if (typeof width !== 'number' || typeof height !== 'number' || typeof additionalMeasure !== 'number') {
    console.error('Todos los valores deben ser números');
    return null;
  }

  if (width <= 0 || height <= 0 || additionalMeasure <= 0) {
    console.error('Los valores deben ser mayores que 0');
    return null;
  }

  if (additionalMeasure >= width) {
    console.error('El ancho del proyectante debe ser menor que el ancho total');
    return null;
  }

  const verticalElements = {
    'Marco': height + 5,
    'Refuerzo Marco': height - 126,
    'Hoja Proyectante': height - 55,
    'Refuerzo Hoja Proyectante': height - 222,
    'Junquillo Fija': height - 80,
    'Junquillo Proyectante': height - 176,
    'Palillo': height - 68,
  };

  const horizontalElements = {
    'Marco': width + 5,
    'Refuerzo Marco': width - 126,
    'Hoja Proyectante': additionalMeasure - 33,
    'Refuerzo Hoja Proyectante': additionalMeasure - 200,
    'Junquillo Fija': width - additionalMeasure - 58,
    'Junquillo Proyectante': additionalMeasure - 154,
  };

  const barrasNecesarias = {};
  const largoBarra = 6000; // mm

  // Calcular barras para elementos verticales
  for (const [perfil, largo] of Object.entries(verticalElements)) {
    // El palillo solo necesita 1 pieza, los demás necesitan 2
    const cantidadPiezas = perfil === 'Palillo' ? 1 : 2;
    const piezasVerticales = Array(cantidadPiezas).fill(largo);
    
    barrasNecesarias[perfil] = {
      cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
      desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
      piezasVerticales,
      piezasHorizontales: [],
      largoTotal: largo * cantidadPiezas
    };
  }

  // Calcular barras para elementos horizontales y combinar con verticales
  for (const [perfil, largo] of Object.entries(horizontalElements)) {
    const cantidadPiezas = 2;
    const piezasHorizontales = Array(cantidadPiezas).fill(largo);
    
    if (!barrasNecesarias[perfil]) {
      barrasNecesarias[perfil] = {
        cantidadBarras: Math.ceil((largo * cantidadPiezas) / largoBarra),
        desperdicioMm: (Math.ceil((largo * cantidadPiezas) / largoBarra) * largoBarra) - (largo * cantidadPiezas),
        piezasVerticales: [],
        piezasHorizontales,
        largoTotal: largo * cantidadPiezas
      };
    } else {
      const largoTotalCombinado = (largo * cantidadPiezas) + barrasNecesarias[perfil].largoTotal;
      barrasNecesarias[perfil] = {
        ...barrasNecesarias[perfil],
        cantidadBarras: Math.ceil(largoTotalCombinado / largoBarra),
        desperdicioMm: (Math.ceil(largoTotalCombinado / largoBarra) * largoBarra) - largoTotalCombinado,
        piezasHorizontales,
        largoTotal: largoTotalCombinado
      };
    }
  }

  return {
    vertical: verticalElements,
    horizontal: horizontalElements,
    barrasNecesarias,
    type: 'Proyectante + Fijo (palillo)',
    photo: "/fotos/Proyectante+fijo.jpg" ,
  };
};

export const calculateVidriosProyectanteFijo = (height, width, additionalMeasure) => {
  console.log('Entrada calculateVidriosProyectanteFijo:', {
    height,
    width,
    additionalMeasure
  });

  if (typeof height !== 'number' || typeof width !== 'number' || typeof additionalMeasure !== 'number') {
    console.error('Los valores deben ser números');
    return null;
  }

  return {
    fijo: {
      vertical: height - 88,
      horizontal: width - additionalMeasure - 66
    },
    proyectante: {
      vertical: height - 184,
      horizontal: additionalMeasure - 162
    }
  };
};
